export default class StylesUtil {
  constructor() {
    this.theme = null
  }

  setTheme(theme) {
    this.theme = theme
  }

  spinner() {
    return {
      'border-top-color': this.theme.buttons.submit.spinnerColor,
    }
  }

  incomingMessage() {
    return {
      'background-color': this.theme.chat.bubble.dealer.backgroundColor,
      color: this.theme.chat.bubble.dealer.textColor,
    }
  }

  outgoingMessage() {
    return {
      'background-color': this.theme.chat.bubble.user.backgroundColor,
      color: this.theme.chat.bubble.user.textColor,
    }
  }

  chatWindowHeaderLogo() {
    return {
      'border-radius': this.theme.header.logo.radius,
      display: this.theme.header.logo.display,
    }
  }

  chatWindowHeaderText() {
    return {
      color: this.theme.header.text.color,
      'font-size': this.theme.header.text.font.size,
      'font-weight': this.theme.header.text.font.weight,
    }
  }

  chatWindowHeaderContainer() {
    return {
      'background-color': this.theme.header.backgroundColor,
    }
  }

  submitButton() {
    return {
      'background-color': this.theme.buttons.submit.backgroundColor,
      'border-color': this.theme.buttons.submit.borderColor,
      color: this.theme.buttons.submit.textColor,
    }
  }

  launcherContainer() {
    return {
      'background-color': this.theme.buttons.launcher.backgroundColor,
      bottom: this.theme.body.bottomOffsetPixels,
      'margin-top': '25px',
    }
  }

  launcherMobileClass() {
    return this.theme.buttons.launcher.mobileDisplay === 'false' ? 'mobile-hide' : ''
  }

  chatWindow() {
    return {} // Keep this it will probably be needed in the future.
  }

  chatWindowContainer() {
    return {
      bottom: this.theme.body.bottomOffsetPixels,
      height: 'calc(100vh - calc(15px + ' + this.theme.body.bottomOffsetPixels + '))',
    }
  }
}
